import React from 'react'

const WhatCard = ({year,title,desc,institue}) => {
  return (
    <>
       <div className='bg-cardcolor mt-10 flex flex-col gap-y-2 box-border px-6 flex-wrap w-full justify-evenly  '>
        <p className='mt-4 bg-red rounded-md p-1 w-fit text-white'>{year}</p>
        <p className='text-white text-xl capitalize'>{title}</p>
        <p className='text-red capitalize text-xl'>{institue}</p>
        <p className='text-abouttext mb-4'>{desc}</p> 
      </div>
    </>
  )
}

export default WhatCard
